import { Component } from "@angular/core";
import { Constants } from "../common/constants";
import { GUI } from "../common/gui";
import { HttpUtils } from "../common/http-utils";
import { LoaderService } from "../common/loader-service";
import { LocalStorage } from "../common/local-storage";
import { Toast } from "../common/toast";
import { Utils } from "../common/utils";
import { ActivatedRoute, Params } from "@angular/router";

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.css']
})
export class PaymentSuccessComponent {

  paidApplicationsList : any = [];

  paymentMessage : any = {};

  isServerResponseCome : boolean = false;

  paymentData: string = "";

  constructor( private activatedRoute: ActivatedRoute, private httpUtils: HttpUtils, private toast: Toast, public constants: Constants, private loaderService: LoaderService, private localStorage: LocalStorage, private gui: GUI, private utils: Utils) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.paymentData = params['paymentData'];
    });
    this.fetchUserPaidApplications();
  }

  private fetchUserPaidApplications(){
    this.loaderService.startLoader();
    const loggedUserId = this.localStorage.getLoggedUserId();
    this.httpUtils.fetchUserPaidApplications(loggedUserId, this.paymentData).then(serverResponse => {
      this.loaderService.stopLoader();
      if(serverResponse.responseCode === this.constants.STATUS_SUCCESS){
        this.paidApplicationsList = serverResponse.paymentApplications;
        this.paymentMessage = serverResponse.paymentMessage;
        this.isServerResponseCome = true;
      } else {
        this.toast.showErrorToast(serverResponse.responseMsg);
      }
    });
  }

  openDashboard(){
    this.gui.openDashboardPage();
  }

  viewApplication(applicantId: string): void {
    this.gui.openApplicationViewPage(applicantId);
  }

  checkPaymentStatus(applicantId: string): void {
    this.loaderService.startLoader();
    const loggedUserId = this.localStorage.getLoggedUserId();
    this.httpUtils.checkPaymentStatusOnIOS(loggedUserId, applicantId, true).then(serverResponse => {
      this.loaderService.stopLoader();
      if(serverResponse.responseCode === this.constants.STATUS_SUCCESS){
        this.paidApplicationsList = serverResponse.paymentApplications;
        this.paymentMessage = serverResponse.paymentMessage;
        
        const checkPaymentResponseCode = serverResponse.checkPaymentResponseCode; 
        const checkPaymentResponseMsg = serverResponse.checkPaymentResponseMsg;
        if(checkPaymentResponseCode === this.constants.STATUS_SUCCESS) {
          this.toast.showSuccessToast(checkPaymentResponseMsg);
        } else {
          this.toast.showErrorToast(checkPaymentResponseMsg);
        }
      } else {
        this.toast.showErrorToast(serverResponse.responseMsg);
      }
    });
  }

}
